(function () {
  const products = {};
  const configs = {};

  if (!customElements.get("upsell-products")) {
    class UpsellProducts extends HTMLElement {
      constructor() {
        super();

        this.productSelectedVariantSKU = this.getAttribute(
          "product-selected-variant-sku"
        );

        document.querySelectorAll("script.upsell-product").forEach((el) => {
          const product = JSON.parse(el.textContent);
          products[product.id] = product;
        });

        document.querySelectorAll("script.upsell-config").forEach((el) => {
          const config = JSON.parse(el.textContent);
          const productId = el.getAttribute("data-product-id");
          configs[productId] = config;
        });

        this.render();
      }

      render() {
        this.innerHTML = ``;

        const order = [
          "variant",
          "multi-checkbox",
          "checkbox",
          "simple-checkbox",
        ];

        Object.values(products)
          .sort((a, b) => order.indexOf(a.x) - order.indexOf(b.x))
          .forEach((product) => {
            const productJSON = JSON.stringify(product);
            const configJSON = JSON.stringify(configs[product.id]);

            const item = document.createElement("upsell-product-item");
            item.setAttribute("product-id", product.id);
            item.setAttribute(
              "product-selected-variant-sku",
              this.productSelectedVariantSKU
            );

            this.appendChild(item);
          });
      }
    }

    customElements.define("upsell-products", UpsellProducts);
  }

  if (!customElements.get("upsell-product-item")) {
    class UpsellProductItem extends HTMLElement {
      static get observedAttributes() {
        return ["product-selected-variant-sku", "product-selected-quantity"];
      }

      constructor() {
        super();

        this.productId = this.getAttribute("product-id");
        this.productSelectedVariantSKU = this.getAttribute(
          "product-selected-variant-sku"
        );

        this.product = products[this.productId];
        this.config = configs[this.productId];

        this.onChangeProductVariant = this.onChangeProductVariant.bind(this);

        window.subscribe("variant:change", this.onChangeProductVariant);

        this.render();
      }

      get variant() {
        if (this.product.variants.length == 1) {
          return this.product.variants[0];
        }

        if (this.config.sku && Object.keys(this.config.sku).length > 0) {
          return Object.entries(this.config.sku).find((entry) =>
            entry[1].some((prefixSKU) =>
              this.selectedVariantSKU.startWiths(prefixSKU)
            )
          );
        }
      }

      get quantity() {
        switch (this.config.quantityRule) {
          case "DEFAULT": {
            return 1;
          }

          case "ALWAY_EQUAL_TO_MAIN_PRODUCT":
          case "EQUAL_TO_MAIN_PRODUCT_BUT_CAN_CHANGE_IN_CART": {
            return this.getAttribute("product-selected-quantity") || 1;
          }

          default: {
            return this.config.quantity || 1;
          }
        }
      }

      onChangeProductVariant(variant) {
        this.setAttribute("product-selected-variant-sku", variant.sku);
      }

      simpleCheckboxTemplate() {
        const template = document
          .querySelector("template#simple-checkbox-template")
          .content.cloneNode(true);

        const input = template.querySelector("input");
        const label = template.querySelector("label");
        const title = template.querySelector(".title");
        const price = template.querySelector(".price");
        const description = template.querySelector(".description");

        input.id = "Product-" + this.product.id;
        label.setAttribute("for", "Product-" + this.product.id);
        title.textContent = this.config.title;
        price.textContent = "+" + Shopify.formatMoney(this.variant.price);
        description.textContent = this.config.description;

        if (this.config.defaultSelect) {
          input.checked = true;
          this.setAttribute("selected-variant-id", this.variant.id);
        }
        
        this.setAttribute("quantity", this.quantity);

        input.addEventListener("change", (e) => {
          const checked = e.target.checked;

          if (checked) {
            this.setAttribute("selected-variant-id", this.variant.id);
          } else {
            this.removeAttribute("selected-variant-id");
          }
        });

        return template;
      }

      render() {
        this.innerHTML = ``;
        const shadow = this.attachShadow({ mode: "open" });

        let template;

        switch (this.config.layout) {
          case "simple-checkbox": {
            template = this.simpleCheckboxTemplate();
          }
        }

        this.template && this.template.remove();

        this.template = template;
        shadow.append(this.template);
      }

      attributeChangedCallback(name, oldValue, newValue) {
        switch (name) {
          case "product-selected-quantity": {
            if (this.config.quantityRule == "ALWAY_EQUAL_TO_MAIN_PRODUCT" || this.config.quantityRule == "EQUAL_TO_MAIN_PRODUCT_BUT_CAN_CHANGE_IN_CART") {
              this.setAttribute("quantity", this.quantity);
            }
          }
        }
      }
    }

    customElements.define("upsell-product-item", UpsellProductItem);
  }

  $(document).on("ready", function() {
    window.ctasdk.beforeAddToCart = function () {
      // Add upsell item to form data
      const upsellProductItems = document.querySelectorAll("upsell-product-item");
  
      const selectedUpsellProducts = [];
      
      for (let upsellProductItem of upsellProductItems) {
        const selectedVariantId = upsellProductItem.getAttribute("selected-variant-id");
        const quantity = upsellProductItem.getAttribute("quantity");
  
        if (selectedVariantId) {
          const item = {
            id: selectedVariantId,
            qty: quantity,
            properties: {}
          };
  
          if (this.cart) {
            item.sections = this.cart.getSectionsToRender().map((section) => section.id);
            item.sections_url = window.location.pathname;
            
            this.cart.setActiveElement(document.activeElement);
          }
          
          selectedUpsellProducts.push(item);
        }
      }
  
      selectedUpsellProducts.forEach(p => window.ctasdk.addAdditionalVariant(p))
  
      return true;
    };
  });
})();
